import { render, staticRenderFns } from "./ModalKitsV2.vue?vue&type=template&id=0cfe5f08&scoped=true&"
import script from "./ModalKitsV2.vue?vue&type=script&lang=js&"
export * from "./ModalKitsV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalKitsV2.vue?vue&type=style&index=0&id=0cfe5f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe5f08",
  null
  
)

export default component.exports